import { eventBus } from '../app';

export default {
    delimiters: ['${', '}'],
    template: '#modal-update-details-template',
    props: {},

    data() {
        return {
            show: false
        }
    },

    created() {
        document.addEventListener('keyup', (event) => {
            if (event.keyCode == 27) {
                this.toggleModal();
            }
        });

        eventBus.$on('update-details', this.openModal);
    },

    mounted() {
    },

    beforeDestroy() {
        eventBus.$off('update-details', this.openModal);
    },

    methods: {
        close() {
            this.show = false;
        },

        toggleModal() {
            this.show = !this.show;
        },

        openModal() {
            this.show = true;
        }
    }
};
